import { type AuthenticationResult, type Configuration, EventType, PublicClientApplication } from '@azure/msal-browser';

// @ai-generated 2026-10-29T10:48:14+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
/** An initialized MSAL instance whose active account follows every sign-in and token renewal. */
export async function initializeMsal(configuration: Configuration): Promise<PublicClientApplication> {
    const msalInstance = new PublicClientApplication(configuration);
    await msalInstance.initialize();

    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.enableAccountStorageEvents();

    msalInstance.addEventCallback((event) => {
        const isSuccess =
            event.eventType === EventType.LOGIN_SUCCESS ||
            event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
            event.eventType === EventType.SSO_SILENT_SUCCESS;
        if (isSuccess && event.payload) {
            msalInstance.setActiveAccount((event.payload as AuthenticationResult).account);
        }
    });

    return msalInstance;
}
